
let language = {
    RENAME_FOLDER_RENAME_FOLDER_TITLE: "重命名文件夹",
    RENAME_FOLDER_FOLDER_NAME_LABEL: "文件夹名称",

    // 
    RENAME_FOLDER_CANCEL_BTN: "取消",
    RENAME_FOLDER_RENAME_BTN: "重命名",


    RENAME_FOLDER_RENAME_PATTERN_TIP: "文件名不能包含以下字符: \\ \/ \: \* \? \" \< \> \|",
};

export { language }